import { render, staticRenderFns } from "./BestUpload.vue?vue&type=template&id=2872750a&scoped=true"
import script from "./BestUpload.vue?vue&type=script&lang=js"
export * from "./BestUpload.vue?vue&type=script&lang=js"
import style0 from "./BestUpload.vue?vue&type=style&index=0&id=2872750a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872750a",
  null
  
)

export default component.exports